import React, { useState } from 'react'
import './Find.css'
import moment from 'moment'
import { toast } from 'react-toastify'
import axios from 'axios'
import { Locations, ActTypes } from '../../Constants';
import { SplitName } from '../../Utilities.js'

export default function Find() {

  const [actType, setActType ] = useState("")
  const [name, setName ] = useState("")
  const [email, setEmail ] = useState("")
  const [date, setDate ] = useState("")
  const [startTime, setStartTime ] = useState("")
  const [endTime, setEndTime ] = useState("")
  const [location, setLocation ] = useState("")
  const [venue, setVenue ] = useState("")
  const [notes, setNotes ] = useState("")
  const [loading, setLoading ] = useState(false)


  // create client account, save the quote, inform artists
  const handleSubmit = () => {
    if(moment(date).isBefore(moment())){
      toast.error("Please add a date in the future")
    } else if (!name || !email || !date || !venue || !actType || !startTime || !endTime) {
      toast.error("Please add all required fields")
    } else {
      setLoading(true)

      const { firstName, lastName } = SplitName(name);

      axios.post(`${process.env.REACT_APP_API}/users/create-new-client`, {
        firstName,
        lastName,
        email,
        img:"https://caretestresources.s3.eu-west-2.amazonaws.com/avatar.png"
      })
      .then((userResponse) => {
        let payload = {
          title: "Request",
          date: moment(date).format("YYYY-MM-DD"),
          name,
          email,
          clientId: userResponse.data.clientId,
          info: {actType, startTime, endTime, venue, location},
          openRequest: true,
          notes, backgroundColor:'#ecbdba',
          borderColor:'#ecbdba',
          textColor:'#fff'
        }

        axios.post(`${process.env.REACT_APP_API}/requests/create-new-request`, payload)
        .then(() => {
          if (userResponse.status === 201) {
            toast.success("Successfully sent request and created account")
          } else { // should be 200
            toast.success("Successfully sent request")
          }
          setLoading(false)

          // clear the form once everything successful
          setName("");setDate("");setEmail("");setNotes("");setActType("");setStartTime("");setEndTime("");setVenue("");setLocation("")
        })
        .catch((error) => {
          toast.error("Error submitting request");
        })
      })
      .catch((error) => {
        if (error.response?.data?.message) {
          // display a specific server error message
          toast.error(error.response.data.message);
        } else {
          // handle other errors
          toast.error("There was a problem submitting your request. Please try again.");
        }

        setLoading(false)
      })
    }
  }


  return (
    <div id='find-page' >
      <div style={{width:600}}>
        <h1 id='post-header'>Post a wedding request - We'll take care of the rest</h1>
        <p style={{color: 'grey', fontSize:20, fontWeight: 600}}>Get responses from First Dance Music's tried and trusted musicians</p>
      </div>

      <div>

      <div className='enquire-container' >
        
        <label style={{marginBottom: 5}}>Date of wedding</label>
        <input 
            className='single-input'
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
        />

        <div className='vertical-spacer' />

        <input 
            className='top-input' 
            type='text' 
            placeholder='Full name' 
            value={name}
            onChange={(e) => setName(e.target.value) }
        />
        <input 
            className='bottom-input' 
            type='text' 
            placeholder='Email address' 
            value={email}
            onChange={(e)=>setEmail(e.target.value)}
        />

        <div className='vertical-spacer' />

        <div style={{display:'flex', justifyContent:'space-between'}}>
            <label>Start time (estimate)</label>
            <label style={{marginLeft: 10}}>End time (estimate)</label>
        </div>
        
        <div style={{width: '100%', display:'flex', justifyContent: 'space-between', alignItems:'center'}}>
            <input className='left-input'  type="time"
              value={startTime}
              onChange={(e) => setStartTime(e.target.value)}
            />

            <input className='right-input' type="time"
              value={endTime}
              onChange={(e) => setEndTime(e.target.value)}
            />
        </div>

        <div className='vertical-spacer' />

        <input 
            className='top-input'
            type="text"
            value={venue} 
            onChange={(e)=>setVenue(e.target.value)}
            placeholder='Venue name'
        />
      
        <select 
            className='middle-input'
            value={location}
            onChange={(e) => setLocation(e.target.value)}
        >
            <option value="">
                <em>Select location</em>
            </option>
            {Locations.map((location) => (
                <option key={location} value={location}>
                  {location}
                </option>
                ))
            }
        </select>

        <select 
            className='bottom-input'
            value={actType}
            onChange={(e)=>setActType(e.target.value)}
        >
            <option value="">
                <em>Act type</em>
            </option>
            {ActTypes.map((type, i) => (
                <option key={i} value={type.name}>
                  {type.name}
                </option>
              ))
            }
        </select>

        <div className='vertical-spacer' />

       
        <textarea 
        style={{resize: 'none', height: 150, padding: 10}}
            className='single-input'
            placeholder='Notes e.g. drinks reception, first dance, start times etc'
            value={notes}
            onChange={(e)=>setNotes(e.target.value)}
        />


        <div className='vertical-spacer' />

        


      <button className='modal-btn' onClick={handleSubmit} disabled={loading}>
        {loading ? 'Requesting...' : "Request quote"}
      </button>

      <p>
            <small>
              <em>
                By submitting this form you agree to us creating an account for you with the provided email.<br />
                This will only be used for the purpose of your booking and its removal can be requested at any time.
              </em>
            </small>
          </p>


      </div>
    </div>
    </div>
  )
}
